<template>
  <div
    v-if="moleculeSubMenu"
    class="m-edition-section-content-info"
  >
    <MoleculeEditionSectionContentSubMenu
      :is="moleculeSubMenu"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionSectionContentSubMenu',

  props: {
    section: {
      type: String,
      default: ''
    },

    subedition: {
      type: String,
      default: ''
    },

    subject: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      moleculeSubMenu: null
    }
  },

  watch: {
    subedition () {
      this.getSubmenu()
    },

    subject () {
      this.getSubmenu()
    }
  },

  created () {
    this.getSubmenu()
  },

  methods: {
    getSubmenu () {
      this.moleculeSubMenu = null
      const menu = this.$i18n.messages[this.$i18n.locale].mEditionMenu[this.$route.meta.isEdition]
      if (this.subject && menu[this.subject[0].toLowerCase() + this.subject.slice(1)].submenu) {
      import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}SubMenu`)
        .then(subMenu => {
          this.moleculeSubMenu = subMenu.default
        })
        .catch(() => {
          this.moleculeSubMenu = null
        })
      } else if (this.subedition &&
        menu[this.subject[0].toLowerCase() + this.subject.slice(1)].children[this.subedition[0].toLowerCase() + this.subedition.slice(1)].submenu) {
        import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}${this.subedition}SubMenu`)
          .then(subMenu => {
            this.moleculeSubMenu = subMenu.default
          })
          .catch(() => {
            this.moleculeSubMenu = null
          })
      }
    }
  }
}
</script>
